<template>
    <div class="page">
        <div class='warp'>
            <div class='header'>
                <img src="/img/shuiyi/logo1.png" class='logo' alt="">
                <img src="/img/shuiyi/logo2.png" class='logothree' alt="">
                <img :src="playicon" class='play' @click='turnplay' alt="">
            </div>
            <div class='mainWarp'>
                <div>
                    <img src="/img/shuiyi/zi.png" class='zi' alt="">
                </div>
            </div>
            <div class='pro'>
                <img src="/img/shuiyi/button.png" class='buttonicon' @click='videoplay' v-if="loading" alt="">
                <img src="/img/shuiyi/lineicon.png" class='lineicon' alt="">
                <p class='progresstext'>{{progress}}%</p>
            </div>
            <div class='skip' @click='skipaction'>
                <p class='jump'>跳过</p>
                <img src="/img/shuiyi/bird.png" class='birdicon' alt="">
            </div>
        </div>
        <audio
            src="/media/shuiyi.mp3"
            loop
            autoplay
            preload="auto"
            v-if="audioPlayerShow"
            ref="music">
        </audio>
        <video
            src="/media/shuiyi.mp4"
            preload="auto"
            x-webkit-airplay="true"
            playsinline="true"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            ref="videoPlayer"
            class="video-player"
            @canplay="videoCanPlay"
            @ended="ended"
            v-show="videoPlayerShow"
            >
        </video>
        <p class='skipvideo' v-show='videoPlayerShow' @click='ended'>跳过</p>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            playicon: '/img/shuiyi/ic_music_note.png',
            isplay: true,
            progress: 0,
            timer: null,
            loading: false,
            audioPlayerShow: true,
            videoPlayerShow: false
        };
    },
    methods: {
        turnplay() {
            // eslint-disable-next-line
            window._hmt.push(['_trackEvent', '市场3.8节-音乐播放点击', '音乐播放点击数量', window.location.href]);
            this.isplay = !this.isplay;
            if (this.isplay) {
                this.playicon = '/img/shuiyi/ic_music_note.png';
                this.$refs.music.play();
            }
            else {
                this.playicon = '/img/shuiyi/ic_music_notetwo.png';
                this.$refs.music.pause();
            }
        },
        videoCanPlay() {
            clearInterval(this.timer);
            setTimeout(() => {
                this.timer = setInterval(() => {
                    this.progress += 1;
                    if (this.progress >= 100) {
                        this.progress = 100;
                        clearInterval(this.timer);
                        this.loading = true;
                    }
                }, 10);
            }, 800);
        },
        ended() {
            this.$refs.videoPlayer.pause();
            this.$emit('skipaction');
            this.videoPlayerShow = false;
        },
        videoplay() {
            this.$refs.music.pause();
            this.videoPlayerShow = true;
            this.audioPlayerShow = false;
            this.$refs.videoPlayer.play();
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-视频播放点击', '视频播放点击数量', window.location.href]);
        },
        skipaction() {
            this.$emit('skipaction');
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-跳过点击（去尾页）', '跳过点击数量', window.location.href]);
        }
    },
    mounted() {
        const that = this;
        // --创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
        document.addEventListener('touchstart', () => {
            function audioAutoPlay() {
                if (that.$refs.music) {
                    that.$refs.music.play();
                }
            }
            audioAutoPlay();
        });
        this.timer = setInterval(() => {
            this.progress += 1;
            if (this.progress >= Math.floor((Math.random() * 20) + 50)) {
                clearInterval(this.timer);
                setTimeout(() => {
                    this.videoCanPlay();
                }, 2000);
            }
        }, 15);
    },
    created() {
    }
};
</script>

<style lang="stylus" scoped>
.page
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 0.28rem
    align-items center
    justify-content center
    background-color #fff
    background url('http://wwj.jijiagames.com/web/act/20190307/shouye.png') 0 0/100% 100% no-repeat
    .warp
        width 100%
        height 96%
        border 0.05rem solid #fff
        flex 1
        display flex
        position relative
        .header
            width 100%
            height 10%
            position relative
            .logo
                width 0.77rem
                height 0.68rem
                position absolute
                top 0.17rem
                left 0.13rem
            .logothree
                width 0.65rem
                height 0.65rem
                position absolute
                top 0.19rem
                left 1rem
            .play
                width 0.37rem
                height 0.54rem
                position absolute
                top 0.17rem
                right 0.28rem
        .mainWarp
            flex 1
            .zi
                width 1.83rem
                height 9rem
                position absolute
                top 10%
                left 0.41rem
        .pro
            width 100%
            display flex
            flex-direction column
            align-items center
            justify-content center
            position absolute
            bottom 8%
            .progresstext
                font-size 0.36rem
                line-height 0.32rem
                font-weight normal
                font-stretch normal
                color #ffffff
                position absolute
                left 4.3rem
                bottom -0.06rem
            .buttonicon
                width 1.12rem
                height 1.12rem
                margin-top 0.2rem
            .lineicon
                width 1.53rem
                height 0.1rem
                margin-top 0.4rem
        .skip
            width 100%
            display flex
            flex-direction row
            align-items flex-end
            justify-content flex-end
            padding-right 0.25rem
            flex 1
            position absolute
            bottom 0rem
            -webkit-tap-highlight-color rgba(0,0,0,0)
            -webkit-tap-highlight-color transparent
            .jump
                font-size 0.31rem
                color #9b9b9b
                margin-top 0.14rem
            .birdicon
                width 1rem
                height 0.89rem
    .video-player
        size 100%
        position absolute
        top 0
        background #000
        object-fit fill
        z-index 100
        vertical-align middle
    .video
        size 100%
        position absolute
        top 0
        left 0
        object-fit cover
    #page
        size 100%
        position absolute
        top 0
        left 0
        z-index 1
.skipvideo
    font-size 0.31rem
    color #fff
    z-index 101
    position absolute
    right 0.3rem
    bottom 0.3rem
</style>
